// removed by extract-text-webpack-plugin
module.exports = {"grid-container":"billing-history__grid-container___37kVC"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/settings/billing-history.scss
// module id = 1356
// module chunks = 0